export default __webpack_public_path__ + "static/media/iv.644df3bf.jpg";